export const PROFILE_PROJECT_STATE_ACTIVE = 'active';
export const PROFILE_PROJECT_STATE_ARCHIVE = 'archive';
